import type {
  ICompetingCampaignsResponse,
  IGamificationCampaignDto,
  IGamificationListResponse,
} from "@/@types/gamification";

import {
  COMPETING_CAMPAIGNS_FIRST_PAGE,
  COMPETING_CAMPAIGNS_MAX_PAGES,
} from "../constants/competing-campaigns";

export type CompetingPageResult<TError> =
  | { data: IGamificationListResponse; error?: undefined }
  | { error: TError; data?: undefined };

export type FetchCompetingPage<TError> = (
  page: number,
) => Promise<CompetingPageResult<TError>>;

export type CollectedCompetingCampaigns<TError> =
  | { data: ICompetingCampaignsResponse; error?: undefined }
  | { error: TError; data?: undefined };

export async function collectCompetingCampaigns<TError>(
  fetchPage: FetchCompetingPage<TError>,
): Promise<CollectedCompetingCampaigns<TError>> {
  const campaigns: IGamificationCampaignDto[] = [];
  for (
    let page = COMPETING_CAMPAIGNS_FIRST_PAGE;
    page <= COMPETING_CAMPAIGNS_MAX_PAGES;
    page += 1
  ) {
    const result: CompetingPageResult<TError> = await fetchPage(page);
    if (!result.data) return { error: result.error };
    campaigns.push(...(result.data.data ?? []));
    if (!result.data.pagination?.hasNext) {
      return { data: { campaigns, truncated: false } };
    }
  }
  return { data: { campaigns, truncated: true } };
}
